module.exports = __webpack_public_path__ + "img/icon8.1fa7f7a8.png";